import { observer } from 'mobx-react-lite';
import { useDependencies } from '@servicetitan/react-ioc';
import { Stack, Button, Headline, BodyText } from '@servicetitan/design-system';
import React from 'react';
import classnames from 'classnames';
import { MatField } from 'src/core/components/mat-field';
import styles from './plan-selection-page.less';
import { PlanDetails } from './plan-details';
import * as Utils from '../../forms/application-information-forms-utils';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { ServiceFinanceStore } from '../../../../stores/service-finance.store';

export const PlanSelectionPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const loan = store.applicationForm!.$.Loan;
    const state = store.applicationForm!.$.PrimaryApplicant.$.Document.$.State;
    const products = store.selectedProducts;
    const states = store.getStates();
    const showAllPlans = store.showAllPlans;
    const validate = store.validateField;
    const isLoanAmountValid = store.isLoanAmountValid;
    const plans = store.selectedPlans;
    const selectedPlan = store.selectedPlan;
    const selectPlan = store.selectPlan;
    const unSelectPlan = store.unSelectPlan;

    const getAmount = () =>
        (parseFloat(loan.$.SalesAmount.value) - parseFloat(loan.$.DownPayment.value)).toFixed(2);
    const isFieldsFilled = () => {
        return !!(
            loan.$.SalesAmount.value &&
            loan.$.DownPayment.value &&
            state.value &&
            loan.$.Product.value
        );
    };
    return (
        <>
            <Stack direction="column" justifyContent="flex-start" className="m-y-2 page-content">
                <Stack.Item>
                    <Stack direction="column" justifyContent="flex-start">
                        <Stack.Item>
                            <BodyText subdued size="xsmall" className="m-b-half">
                                Financing provided by
                            </BodyText>
                            <img
                                className={styles.logo}
                                src="assets/images/servicefinance-logo.png"
                            />
                        </Stack.Item>
                        <Stack.Item className="m-y-2">
                            <MatField
                                required
                                fullWidth
                                errorColor
                                fieldState={loan.$.SalesAmount}
                                maxLength={26}
                                formatter={Utils.formatAmount}
                                validator={Utils.amountValidator}
                                label="Sale Amount ($)"
                                onBlur={validate(loan.$.SalesAmount)}
                            />
                        </Stack.Item>
                        <Stack.Item className="m-y-2">
                            <MatField
                                required
                                fullWidth
                                errorColor
                                fieldState={loan.$.DownPayment}
                                maxLength={26}
                                formatter={Utils.formatAmount}
                                validator={Utils.amountValidator}
                                label="Down Payment ($)"
                                onBlur={validate(loan.$.DownPayment)}
                            />
                        </Stack.Item>
                        <Stack.Item className="m-y-2">
                            <FormControl required fullWidth>
                                <InputLabel htmlFor="select">Improvement Type</InputLabel>
                                <Select
                                    inputProps={{ id: 'improvement' }}
                                    value={loan.$.Product.value}
                                    onChange={async (e) => {
                                        loan.$.Product.onChange(e.target.value as string);
                                        await validate(loan.$.Product);
                                    }}
                                >
                                    {products.map((value, index) => (
                                        <MenuItem key={index} value={value}>
                                            {value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack.Item>
                        <Stack.Item className="m-y-2">
                            <FormControl required fullWidth>
                                <InputLabel htmlFor="select">Job State</InputLabel>
                                <Select
                                    inputProps={{ id: 'jobState' }}
                                    value={state.value}
                                    onChange={async (e) => {
                                        state.onChange(e.target.value as string);
                                        await validate(state);
                                    }}
                                >
                                    {states.map((value, index) => (
                                        <MenuItem key={index} value={value}>
                                            {value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
                <Stack.Item className="m-y-4">
                    <Button
                        full
                        primary
                        className={classnames(styles.showAllPlans, {
                            [styles.disabled]: !isFieldsFilled(),
                        })}
                        disabled={!isFieldsFilled()}
                        loading={store.isLoadingPlans}
                        onClick={() =>
                            showAllPlans(
                                loan.$.Product.value,
                                parseFloat(loan.$.SalesAmount.value) -
                                    parseFloat(loan.$.DownPayment.value),
                                state.value
                            )
                        }
                    >
                        Show All Plans
                    </Button>
                </Stack.Item>
                {loan.$.SalesAmount.value && loan.$.DownPayment.value && plans.length > 0 && (
                    <PlanDetails
                        loanAmount={getAmount()}
                        isLoanAmountValid={isLoanAmountValid}
                        plans={plans}
                        selectedPlan={selectedPlan}
                        selectPlan={selectPlan}
                        unSelectPlan={unSelectPlan}
                    />
                )}
            </Stack>
        </>
    );
});
